var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { existsSync, mkdirSync, writeFileSync } from 'fs';
import { mkdir, writeFile } from 'fs/promises';
import { dirname } from 'path';
export const writeFileWithDetection = (path, content, override) => __awaiter(void 0, void 0, void 0, function* () {
    if (!override && existsSync(path)) {
        console.warn(`File ${path} already exists, ignore.`);
        return;
    }
    yield mkdir(dirname(path), { recursive: true });
    return writeFile(path, content, 'utf-8');
});
export const writeFileWithDetectionSync = (path, content, override) => {
    if (!override && existsSync(path)) {
        console.warn(`File ${path} already exists, ignore.`);
        return;
    }
    mkdirSync(dirname(path), { recursive: true });
    return writeFileSync(path, content, 'utf-8');
};
